export const dictionaryPL = {
  Accessibility: "Dostępność",
  Book: "Książka",
  Continue: "Kontynuuj",
  "Continue to checkout": "Kontynuuj do płatności",
  "Enhance your booking": "Ulepsz swoją rezerwację",
  "/hr": "/godzina",
  hr: "godzina",
  hrs: "godziny",
  people: "osób",
  person: "osoba",
  Location: "Lokalizacja",
  "City: Any": "Miasto: Dowolne",
  "State: Any": "Stan: Dowolny",
  "Location: Any": "Lokalizacja: Dowolna",
  "Capacity: Any": "Pojemność: Dowolna",
  Filter: "Filtr",
  Filters: "Filtry",
  "Showing all rooms": "Wyświetlam wszystkie pokoje",
  "1 room found": "Znaleziono 1 pokój",
  "{numberOfRooms} rooms found": "Znaleziono {numberOfRooms} pokoje",
  "No meeting rooms found": "Nie znaleziono sal konferencyjnych",
  "Try changing or clearing some of your filters":
    "Spróbuj zmienić lub wyczyścić niektóre filtry",
  "Clear all filters": "Wyczyść wszystkie filtry",
  "Show results": "Pokaż wyniki",
  Office: "Gabinet",
  "{count} offerings at {locationName}": "{count} ofert w {locationName}",
  "On Demand": "Na żądanie",
  Memberships: "Członkostwa",
  Any: "Każdy",
  "Any location": "Każdy",
  "Any city": "Każdy",
  view: "pogląd",
  "Invitations already sent to:": "Invitations already sent to:",
  and: "oraz",
  "Available on": "Dostępne na",
  "Available on {date}": "Dostępne na {date}",
  "Best price available today": "Najlepsza cena dostępna dziś",
  "Best price available tomorrow": "Najlepsza cena dostępna jutro",
  "Best price available on {date}": "Najlepsza cena dostępna {date}",
  "No available space": "Brak dostępnego miejsca",
  "View More": "Zobacz więcej",
  "Additional offices at this location": "Dodatkowe biura w tej lokalizacji",
  Floor: "Piętro",
  "With window": "Z oknem",
  "Day offices at {locationName}": "Biura dzienne w {locationName}",
  "Not sure?": "Masz pytania?",
  "Talk with us": "Porozmawiaj z nami",
  "We couldn't get a price for this selection. Please try again.":
    "Nie udało się obliczyć ceny dla tego wyboru. Spróbuj ponownie.",
  "We are sorry, but there is no availability for 1 pass":
    "Przepraszamy, ale nie ma wolnych miejsc na 1 karnet",
  "We are sorry, but this date is unavailable at this location. Please pick a different date":
    "Przepraszamy, ale ta data jest niedostępna w tej lokalizacji. Wybierz inną datę",
  "We are sorry, but there is no availability for {number of passes} passes":
    "Przepraszamy, ale nie ma wolnych miejsc na {number of passes} karnety",
  "and we may be able to help you find a solution.":
    "i być może będziemy w stanie pomóc Ci znaleźć rozwiązanie.",
  max: "maks",
  "Have more questions?": "Masz więcej pytań?",
  "Visit our FAQ": "Zobacz nasze FAQ",
  "Frequently asked questions": "Często Zadawane Pytania",
  Directions: "Wskazówki dojazdu",
  "is located at": "znajduje się w",
  "Not available": "Niedostępne",
  Total: "Całkowity",
  to: "do",
  "/day": "/dzień",
  "/hour": "/godzina",
  "/month": "/miesiąc",
  "Quantity:": "Ilość:",
  Quantity: "Ilość",
  Save: "Dalej",
  When: "Kiedy",
  Back: "Z powrotem",
  "Please select a location": "Wybierz lokalizację",
  "Please select date range": "Proszę wybrać zakres dat",
  "Please select # of entries": "Proszę wybrać # wpisów",
  "Please select date": "Proszę wybrać datę",
  "Please select time": "Proszę wybrać czas",
  "Please select duration": "Wybierz czas trwania",
  "Minimum duration": "Minimalny czas trwania",
  "Minimum {count}": "Minimum {count}",
  "Minimum {count} per day": "Minimum {count} za dzień",
  "Minimum {count} per day, based on guest count":
    "Minimum {count} za dzień, w zależności od liczby gości",
  "Minimum {count} per booking": "Minimum {count} za rezerwację",
  "Items per day": "Przedmioty za dzień",
  "Items per booking": "Przedmioty za rezerwację",
  "From {price}/day (min {count}/day)": "Od {price}/dzień (min. {count}/dzień)",
  "{perDay}/day × {days} · {total}": "{perDay}/dzień × {days} · {total}",
  "{perDay}/day": "{perDay}/dzień",
  "{qty} per day × {days} = {items}": "{qty} za dzień × {days} = {items}",
  "Select at least one day": "Wybierz co najmniej jeden dzień",
  each: "za sztukę",
  "Add to booking · {total}": "Dodaj do rezerwacji · {total}",
  "Update booking · {total}": "Zaktualizuj rezerwację · {total}",
  "{count} is the minimum per day. Use Remove from booking if you don't want {name}.":
    "{count} to minimum za dzień. Użyj „Remove from booking”, jeśli nie chcesz: {name}.",
  "{count} is the minimum per booking. Use Remove from booking if you don't want {name}.":
    "{count} to minimum za rezerwację. Użyj „Remove from booking”, jeśli nie chcesz: {name}.",
  "Please select quantity": "Proszę wybrać ilość",
  day: "dzień",
  days: "dni",
  "1 day": "1 dzień",
  "{number of days} days": "{number of days} dni",
  "Valid for {numberOfDays} day from purchase":
    "Ważne {numberOfDays} dzień od zakupu",
  "Valid for {numberOfDays} days from purchase":
    "Ważne {numberOfDays} dni od zakupu",
  "1 hour": "1 godzina",
  "{number of hours} hours": "{number of hours} godziny",
  "1 entry": "1 wpis",
  "{number of entries} entries": "{number of entries} wpisy",
  entry: "wejście",
  entries: "wpisy",
  hour: "godzina",
  hours: "godziny",
  Close: "Zamknij",
  Amenities: "Udogodnienia",
  "per guest": "za gościa",
  "fixed rate": "stawka stała",
  "per item": "za przedmiot",
  "for this space": "za tę przestrzeń",
  "per day": "za dzień",
  "per booking": "za rezerwację",
  "per guest, daily": "za gościa, dziennie",
  "per item, daily": "za przedmiot, dziennie",
  Included: "Wliczone",
  "Add-ons": "Dodatki",
  "Powered by": "Zasilany przez",
  Privacy: "Prywatność",
  Terms: "Zasady i warunki",
  QTY: "ILOŚĆ",
  Subtotal: "Suma częściowa",
  "Cancel for free up to {duration} before your booking":
    "Anuluj za darmo do {duration} przed rezerwacją",
  "Cancel for free up to ": "Anuluj bezpłatnie do ",
  "Cancel for free up to {time} the day before your booking":
    "Anuluj za darmo do {time} w dniu poprzedzającym rezerwację",
  "Fits: {capacity} people max": "Pasuje: {capacity} osób max",
  "Free cancellation before {time} on {date}":
    "Bezpłatne anulowanie przed {time} na {date}",
  "This booking is non-refundable.": "Nie refundowane.",
  "{max} max": "{max} maks",
  "Up to {capacity} people": "Aż do {capacity} osób",
  "Up to {capacity} person": "Aż do {capacity} osoba",
  "End time": "Koniec czasu",
  "Start time": "Czas rozpoczęcia",
  "View all images": "Zobacz wszystkie obrazy",
  "Full name": "Pełne imię i nazwisko",
  "Phone number": "Numer telefonu",
  Email: "E-mail",
  "Number of expected guests": "Liczba oczekiwanych gości",
  "Company Name": "Nazwa firmy",
  "Street address": "Ulica",
  "City / Town": "Miasto",
  "State / Province / Region": "Stan/prowincja/region",
  "State / Province / Region (optional)": "Stan/prowincja/region (opcjonalnie)",
  "Postal code": "Kod pocztowy",
  Country: "Kraj",
  "Tax / VAT / ID number": "Numer NIP / VAT",
  "Enter a promo code": "Wpisz kod promocyjny",
  "Promo code": "Kod promocyjny",
  "Payment details": "Szczegóły płatności",
  "Confirm and Pay": "Potwierdź i zapłać",
  "You won't be charged unless your request is accepted.":
    "Nie zostaniesz obciążony(-a), chyba że Twoja prośba zostanie zaakceptowana.",
  "Request to Book": "Zamów rezerwację",
  "Request to Subscribe": "Zamów subskrypcję",
  "Continue to payment": "Przejdź do płatności",
  "This crash has been reported to us and we will work on resolving the issue as quickly as possible.":
    "Ta awaria została nam zgłoszona i będziemy pracować nad rozwiązaniem problemu tak szybko, jak to możliwe.",
  "By clicking on Confirm and Pay I agree to the":
    "Klikając Potwierdź i zapłać, zgadzam się na",
  "terms and conditions": "zasady i warunki",
  "Billing details": "Szczegóły płatności",
  "Your details": "Twoje szczegóły",
  "Check here to indicate that you have read and agreed to the":
    "Zaznacz tutaj, aby zaznaczyć, że przeczytałeś i wyraziłeś zgodę na",
  Apply: "Stosować",
  "Submitting your request": "Przesyłanie prośby",
  "Please add your full name": "Proszę dodać swoje imię i nazwisko",
  "Please agree to the terms and conditions": "Zaakceptuj regulamin",
  "Please add your company name": "Proszę dodać nazwę swojej firmy",
  "Please add your phone number": "Dodaj swój numer telefonu",
  "Please enter valid phone number": "Proszę podać poprawny numer telefonu",
  "Please add your email": "Dodaj swój adres e-mail",
  "Please enter valid email": "Proszę podać poprawny adres e-mail",
  "Please add billing street address": "Dodaj adres rozliczeniowy",
  "Please add billing city": "Dodaj miasto rozliczeniowe",
  "Please add billing state / province / region":
    "Dodaj stan / prowincję / region rozliczeniowy",
  "Please add postal code": "Proszę dodać kod pocztowy",
  "Please add billing country": "Dodaj kraj rozliczenia",
  "Please add tax information": "Proszę dodać informacje podatkowe",
  "Please enter credit card info": "Wprowadź informacje o karcie kredytowej",
  "Let's talk": "Porozmawiajmy",
  "We would be happy to provide you with more information and answer your specific office needs.":
    "Chętnie udzielimy Ci więcej informacji i odpowiemy na Twoje specyficzne potrzeby biurowe.",
  "First Name": "Imię",
  "Last Name": "Nazwisko",
  "How can we help?": "Jak możemy pomóc?",
  Submit: "Wyślij",
  "Could not get order confirmation":
    "Nie można uzyskać potwierdzenia zamówienia",
  "Your payment could not be completed. Please check your card details or try another payment method.":
    "Nie udało się zrealizować płatności. Sprawdź dane karty lub wybierz inną metodę płatności.",
  "Someone else just booked this space. No payment was taken — the hold on your card will disappear shortly.":
    "Ktoś inny właśnie zarezerwował tę przestrzeń. Nie pobraliśmy żadnej płatności — blokada środków na Twojej karcie wkrótce zniknie.",
  "An add-on you selected just sold out for that date. No payment was taken — the hold on your card will disappear shortly.":
    "Dodatek, który wybrałeś, właśnie się wyprzedał na ten dzień. Nie pobraliśmy żadnej płatności — blokada środków na Twojej karcie wkrótce zniknie.",
  "Choose another time": "Wybierz inny termin",
  "Stripe was not loaded": "Pasek nie został załadowany",
  "The session has expired. Please refresh the page and try again.":
    "Sesja wygasła. Odśwież stronę i spróbuj ponownie.",
  "Card component not found": "Nie znaleziono elementu karty",
  "Payment unsuccessful": "Płatność nie powiodła się",
  "Redirecting you to confirmation page":
    "Przekierowanie do strony potwierdzenia",
  Payment: "Zapłata",
  "Confirmed without payment": "Potwierdzone bez płatności",
  "N/A": "Nie dotyczy",
  "Ending with {last4}": "Ending with {last4}",
  "Confirmed!": "Potwierdzony!",
  "Thank you for booking with us. A confirmation email has been sent to {email}. We are looking forward to seeing you soon.":
    "Dziękujemy za rezerwację u nas. E-mail z potwierdzeniem został wysłany do {email}. Do zobaczenia wkrótce.",
  "Payment method": "Metoda płatności",
  "Phone (optional)": "Telefon (opcjonalnie)",
  "Please enter at least one attendee.":
    "Wprowadź co najmniej jednego uczestnika.",
  "Invite Attendees": "Zaproś uczestników",
  Message: "Wiadomość",
  Name: "Nazwa",
  "e.g. Looking forward to seeing you at {offeringName}!":
    "np. Do zobaczenia w {offeringName}!",
  "Add your attendees below. Their invitation email automatically includes the location, address, and directions.":
    "Dodaj uczestników poniżej. Ich e-mail z zaproszeniem automatycznie zawiera lokalizację, adres i wskazówki dojazdu.",
  "View Invitation": "Zobacz zaproszenie",
  "Will there be others joining you?": "Czy dołączą do ciebie inni?",
  "The invitation email automatically includes the location, address, and directions.":
    "E-mail z zaproszeniem automatycznie zawiera lokalizację, adres i wskazówki dojazdu.",
  attendee: "",
  attendees: "uczestnik",
  "Please add email": "Proszę dodać e-mail",
  "Please add name": "Proszę dodać nazwę",
  "Invitation sent!": "Zaproszenie wysłane!",
  "An email invitation have been sent to your attendees with details and directions.":
    "Do uczestników zostało wysłane zaproszenie e-mail ze szczegółami i wskazówkami.",
  Attendees: "Uczestnicy",
  "Attendees:": "Uczestnicy:",
  Done: "Gotowe",
  "Invitation sent to 1 attendee": "Zaproszenie wysłane do 1 uczestnika",
  "Invitation sent to {number of attendees} attendees":
    "Zaproszenie wysłane do {number of attendees} uczestnicy",
  "{number of hours}": "{number of hours}",
  "{number of entries}": "{number of entries}",
  "{number of days}": "{number of days}",
  "Sorry, we couldn’t find anything matching your search.":
    "Przepraszamy, nie znaleźliśmy niczego pasującego do Twojego wyszukiwania.",
  "Reset Filter": "Resetuj filtr",
  "Select a location": "Wybierz lokalizację",
  "Select quantity": "Wybierz ilość",
  "Select number of guests": "Wybierz liczbę gości",
  "Please select the number of guests": "Proszę wybrać liczbę gości",
  "Select # of entries": "Wybierz liczbę wpisów",
  "{productTypeName} at {locationName}": "{productTypeName} w {locationName}",
  "{productTypeName} to {locationName}": "{productTypeName} do {locationName}",
  Capacity: "Pojemność",
  "Capacity:": "Pojemność:",
  "Image for illustration purpose only":
    "Obraz wyłącznie w celach ilustracyjnych",
  "Send Invitations": "Wysyłać zaproszenia",
  ILS: "ILS",
  "on {cancelledAt}.": "na  {cancelledAt}.",
  "Order cancelled": "Zamówienie anulowane",
  "Cancelled and refunded ": "Anulowane i zwrócone",
  "Cancel Order": "Anuluj zamówienie",
  "Cancel available in {time}": "Anulowanie dostępne za {time}",
  "Cancel temporarily unavailable while invoice is processing":
    "Anulowanie tymczasowo niedostępne podczas przetwarzania faktury",
  "Finalizing the invoice with your space provider. Cancellation will be available shortly.":
    "Finalizujemy fakturę z dostawcą przestrzeni. Anulowanie będzie wkrótce dostępne.",
  "Cancellation temporarily unavailable, available in approximately {minutes} minutes":
    "Anulowanie tymczasowo niedostępne, dostępne za około {minutes} minut",
  "Cancellation now available": "Anulowanie jest już dostępne",
  Cancellation: "Anulowanie",
  "Are you sure you want to cancel and get a refund? This cannot be un-done.":
    "Czy na pewno chcesz anulować i otrzymać zwrot pieniędzy? Tego nie da się cofnąć.",
  "No, do not cancel": "Nie, nie anuluj",
  "Yes, Cancel & Refund": "Tak, anuluj i zwróć pieniądze",
  "Or call us at:": "Lub zadzwoń do nas:",
  "Additional Products": "Dodatkowe produkty",
  "Book now": "Rezerwuj teraz",
  "Coming Soon": "Wkrótce",
  "Manage bookings": "Zarządzaj rezerwacjami",
  "Learn more": "Ucz się więcej",
  Daily: "Codzienny",
  "1 Daily Pass": "1 Dzienny Karnet",
  "Unlimited access": "Nieograniczony dostęp",
  Hourly: "Cogodzinny",
  Confirm: "Potwierdzać",
  "Start from": "Rozpocząć z",
  "There are no offices available for the selected capacity.":
    "Brak dostępnych biur dla wybranej pojemności.",
  Date: "Data",
  Clear: "Dane",
  "Clear all": "Wyczyść wszystko",
  "Our Customers Say": "Opinie naszych klientów",
  "Review from Google": "Opinia od Google",
  phoneNumberOptional: "Numer telefonu (opcjonalnie)",
  "Please add your first name": "Proszę dodać swoje imię",
  "Please add your last name": "Proszę dodać swoje nazwisko",
  "Please enter a valid email": "Proszę wpisać prawidłowy email",
  "Please enter a valid phone number": "Proszę wpisać poprawny numer telefonu",
  "Message can't be blank": "Wiadomość nie może być pusta",
  bookingReasonTitle: "Jaki jest cel Twojej rezerwacji",
  bookingReasonTitleOptional:
    "Powiedz nam więcej o swojej rezerwacji (Opcjonalnie)",
  specialInstructionsTitle: "Instrukcje specjalne (Opcjonalnie)",
  specialInstructionsDisplayTitle: "Instrukcje specjalne",
  "E.g Catering, Beverages or equipment": "np. Catering, Napoje lub Sprzęt",
  missingBookingReasonError: "Dodaj cel swojej rezerwacji",
  bookingReason: "Powód rezerwacji",
  selectADate: "Wybierz datę",
  "More to explore...": "Więcej do odkrycia...",
  backTo: "Wrócić do",
  showFewerAmenities: "Pokaż mniej udogodnień",
  showAllAmenities: "Pokaż wszystkie udogodnienia",
  "Show less": "Pokaż mniej",
  needHelp: "Potrzebuję pomocy?",
  Home: "Strona główna",
  Guest: "Gość",
  Guests: "Goście",
  copy: "Kopiuj",
  copied: "Skopiowane",
  generalInformation: "Informacje ogólne",
  "Single pass": "Przepustka pojedyncza",
  "Select capacity": "Wybierz pojemność",
  "Enter a code": "Wpisz kod",
  "You've already got the best deal! Save your code for another booking.":
    "Masz już najlepszą ofertę! Zachowaj kod na inną rezerwację.",
  "Your code beats the {discount}, so we used it instead.":
    "Twój kod jest lepszy niż {discount}, więc użyliśmy go zamiast niego.",
  "Your code saved {amount} on {appliedTo}. {setAsideOn} already had a better deal: {discount}.":
    "Twój kod zaoszczędził {amount} na {appliedTo}. Dla {setAsideOn} była już lepsza oferta: {discount}.",
  "Your code saved {amount} on {appliedTo}. Your booking already had a better deal: {discount}.":
    "Twój kod zaoszczędził {amount} na {appliedTo}. Twoja rezerwacja miała już lepszą ofertę: {discount}.",
  "your booking": "twojej rezerwacji",
  Update: "Aktualizacja",
  "Update booking details": "Zaktualizuj szczegóły rezerwacji",
  "Select booking details": "Wybierz szczegóły rezerwacji",
  "Book this space": "Zarezerwuj to miejsce",
  "Check availability": "Sprawdź dostępność",
  "Select date": "Wybierz datę",
  "No start dates are available": "Brak dostępnych dat rozpoczęcia",
  "Every date in this membership's start date window is closed or unavailable. Please contact us to arrange a start date.":
    "Wszystkie daty w oknie rozpoczęcia tego członkostwa są zamknięte lub niedostępne. Skontaktuj się z nami, aby ustalić datę rozpoczęcia.",
  City: "Miasto",
  "Book here": "Zarezerwuj tutaj",
  "Select a city": "Wybierz miasto",
  "Select a country": "Wybierz kraj",
  somethingWentWrong: "Coś poszło nie tak",
  availabilityFetchingError:
    "W tej chwili nie możemy sprawdzić dostępnych pokoi, spróbuj ponownie później.",
  "Cancellation policy": "Zasady anulowania rezerwacji",
  "{percent}% refund if cancelled {duration} before booking":
    "{percent}% zwrotu, jeśli anulowane {duration} przed rezerwacją",
  "{percent}% refund if cancelled by {time} the day before your booking":
    "{percent}% zwrotu, jeśli anulowane do {time} w dniu poprzedzającym rezerwację",
  "Payment information": "Informacja o płatności",
  "Thank you {firstName}, we will get back to you as soon as we can and reply to your email at {email}.":
    "Dziękujemy {firstName}, skontaktujemy się z Tobą tak szybko, jak to możliwe i odpowiemy na Twój e-mail na adres {email}.",
  "By providing your card information, you allow {partnerName} to charge your card for future payments in accordance with their ":
    "Podając informacje o swojej karcie, zezwalasz firmie {partnerName} na obciążanie Twojej karty przyszłymi płatnościami zgodnie z jej postanowieniami ",
  "Terms of Service": "Warunki usługi",
  priceInfoMessage: "Cena zależy od dostępności",
  priceInfoMessageV2: "Cena zależy od dostępności.",
  priceChargedMessage: "Nie zostanie jeszcze pobrana żadna płatność.",
  from: "z",
  From: "Z",
  "Already have a reservation": "Masz już rezerwację?",
  Yes: "Tak",
  No: "Nie",
  "We’ve chosen the best possible price for you based on your selections":
    "Na podstawie Twoich wyborów wybraliśmy dla Ciebie najlepszą możliwą cenę",
  "Available spaces": "Dostępne przestrzenie",
  "Here are some additional spaces you might be interested in, available during our working hours 09:00-17:30":
    "Oto kilka dodatkowych miejsc, które mogą Cię zainteresować. Są one dostępne w godzinach 9:00-17:30",
  "Meeting Rooms": "Sale konferencyjne",
  "Discounts subject to date availability":
    "Zniżki w zależności od dostępności w danym terminie",
  "Discount subject to date availability and for meeting rooms only":
    "Zniżki w zależności od dostępności w danym terminie i tylko dla sal konferencyjnych",
  "Book {numberOfHours}+ hours, save {savingValue} on select dates":
    "Zarezerwuj ponad {numberOfHours} godziny i zaoszczędź {savingValue} w wybranych terminach",
  or: "Lub",
  "Additional Spaces": "Dodatkowe przestrzenie",
  "Here are some additional spaces you might be interested in.":
    "Oto kilka dodatkowych przestrzeni, które mogą Cię zainteresować.",
  "Book {numberOfHours}+ hours to unlock {savingDisplay} off.":
    "Zarezerwuj {numberOfHours}+ godzin, aby odblokować {savingDisplay} zniżki.",
  "Additional fees": "Dodatkowe opłaty",
  "varies by layout": "zależy od układu",
  "Special instructions": "Instrukcje specjalne",
  "You're saving {price}": "Oszczędzasz {price}",
  Hours: "Godziny",
  Mon: "Poniedziałek",
  Tue: "Wtorek",
  Wed: "Środa",
  Thu: "Czwartek",
  Fri: "Piątek",
  Sat: "Sobota",
  Sun: "Niedziela",
  AM: "rano",
  PM: "wieczorem",
  "Clear filters": "Wyczyść filtry",
  "Need more flexibility? Discover the benefits of memberships today!":
    "Potrzebujesz większej elastyczności? Odkryj korzyści z członkostwa już dziś!",
  "See details": "Zobacz szczegóły",
  Where: "Gdzie",
  Anywhere: "Gdziekolwiek",
  "{numberOfCities} cities, {numberOfBuildings} buildings":
    "{numberOfCities} miast, {numberOfBuildings} budynków",
  "{numberOfStates} states, {numberOfBuildings} buildings":
    "{numberOfStates} województw, {numberOfBuildings} budynków",
  "Clear selection": "Wyczyść wybór",
  "Clear search": "Wyczyść wyszukiwanie",
  'No locations match "{query}"': 'Żadna lokalizacja nie pasuje do "{query}"',
  "See results": "Zobacz wyniki",
  "Search for a city": "Wyszukaj miasto",
  "Search for a state": "Wyszukaj województwo",
  Neighborhood: "Dzielnica",
  "Select a neighborhood": "Wybierz dzielnicę",
  "Search for a neighborhood": "Wyszukaj dzielnicę",
  "{numberOfNeighborhoods} neighborhoods, {numberOfBuildings} buildings":
    "{numberOfNeighborhoods} dzielnic, {numberOfBuildings} budynków",
  "Similar meeting rooms available for a larger number of guests":
    "Podobne sale konferencyjne dostępne dla większej liczby gości",
  "Similar spaces available for a larger number of guests":
    "Podobne przestrzenie dostępne dla większej liczby gości",
  "Similar spaces available at other times":
    "Podobne przestrzenie dostępne w innych terminach",
  "Similar spaces available in nearby locations":
    "Podobne przestrzenie dostępne w pobliskich lokalizacjach",
  "Similar meeting rooms available at other times":
    "Podobne sale konferencyjne dostępne w innych terminach",
  "Similar meeting rooms available in nearby locations":
    "Podobne sale konferencyjne dostępne w pobliskich lokalizacjach",
  "Other meeting rooms at {locationName}":
    "Inne sale konferencyjne w {locationName}",
  "Other meeting rooms available at the same time":
    "Inne sale konferencyjne dostępne w tym samym terminie",
  "Looks like there aren’t any exact matches.":
    "Wygląda na to, że nie ma dokładnych dopasowań.",
  "Consider adjusting your filters or browsing similar spaces below.":
    "Rozważ dostosowanie filtrów lub przejrzyj podobne treści poniżej.",
  "The dates you selected may be unavailable at this location. Try different dates or clear the date filter.":
    "Wybrane daty mogą być niedostępne w tej lokalizacji. Wypróbuj inne daty lub wyczyść filtr daty.",
  "Clear locations": "Wyczyść lokalizacje",
  "Clear number of guests": "Wyczyść liczbę gości",
  "Clear date": "Wyczyść datę",
  "See all": "Zobacz wszystko",
  "Show more": "Pokaż więcej",
  "Book {numberOfHours}+ hours, save {savingDisplay}":
    "Zarezerwuj {numberOfHours}+ godziny, zaoszczędź {savingDisplay}",
  "Not ready for a membership? Try our workspaces for a day":
    "Nie gotowy na członkostwo? Spróbuj nasze biura na dzień",
  "Best value": "Najlepsza wartość",
  "Prices vary by day. Select a date to choose a time.":
    "Ceny różnią się w zależności od dnia. Wybierz datę, aby wybrać godzinę.",
  Duration: "Długość",
  min: "minuta",
  mins: "minuty",
  "1 hr": "1 godzina",
  "{numberOfHours} hrs": "{numberOfHours} godzin",
  "{numberOfMinutes} mins": "{numberOfMinutes} minut",
  "You're saving {savingDisplay}!": "Oszczędzasz {savingDisplay}!",
  "loading...": "załadunek...",
  "First {cycles} months payment": "Pierwsze {cycles} miesiące płatności",
  "Continue with Payment": "Kontynuuj płatność",
  "After the initial month, you'll be billed {amount}/month on or about the first of the month.":
    "Po upływie pierwszego miesiąca opłata w wysokości {amount} miesięcznie będzie naliczana pierwszego dnia miesiąca lub około tego dnia.",
  "{percent}% off for your whole membership":
    "{percent}% zniżki przez cały okres członkostwa",
  "Discounted price for your whole membership":
    "Cena po rabacie przez cały okres członkostwa",
  "Promo code copied to clipboard!": "Kod promocyjny skopiowano do schowka!",
  "Thank you for signing up!": "Dziękujemy za zapisanie się!",
  "Your {savingDisplay} off code is": "Twój kod rabatowy {savingDisplay} to",
  "Your promotion code will be applied automatically at checkout.":
    "Kod promocyjny zostanie automatycznie zastosowany podczas realizacji transakcji.",
  "Please provide a valid email.": "Proszę podać prawidłowy adres e-mail.",
  "Not now": "Nie teraz",
  "Daily rate includes {bookable_start_time} - {bookable_end_time} access":
    "Stawka dzienna obejmuje dostęp od {bookable_start_time} do {bookable_end_time}",
  "Get {savingDisplay} off your next order!":
    "Otrzymaj {savingDisplay} zniżki na kolejne zamówienie!",
  "Sign up to receive exclusive promotions and discounts, and receive {savingDisplay} off your next order!":
    "Zarejestruj się, aby otrzymywać ekskluzywne promocje i rabaty oraz zyskaj {savingDisplay} zniżki na kolejne zamówienie!",
  "Sign up": "Zapisać się",
  "By signing up, you agree to receive emails related to your discount. One discount per customer/email. Not combinable with other offers.":
    "Rejestrując się, wyrażasz zgodę na otrzymywanie wiadomości e-mail związanych z Twoim rabatem. Jeden rabat na klienta/e-mail. Nie można łączyć z innymi ofertami.",
  "{savingDisplay} off applied at checkout":
    "{savingDisplay} zniżki zostanie naliczone przy kasie",
  "Get {savingDisplay} Off!": "Otrzymaj {savingDisplay} zniżki!",
  "Your promo code has been applied!":
    "Twój kod promocyjny został zastosowany!",
  "Checking available start times...":
    "Sprawdzanie dostępnych godzin rozpoczęcia...",
  "No available start times for this date.":
    "Brak dostępnych godzin rozpoczęcia w tym dniu.",
  "We'll show rooms that fit": "Pokażemy pokoje, które pomieszczą",
  "and more spacious options if available.":
    "i bardziej przestronne opcje, jeśli są dostępne.",
  "{count}+ people": "{count}+ osób",
  "event spaces": "przestrzenie eventowe",
  "Contact us": "Skontaktuj się z nami",
  "For larger groups, explore our": "Dla większych grup, zbadaj nasze",
  "for larger groups": "dla większych grup",
  Who: "Kto",
  "Any number of people": "Dowolna liczba osób",
  "contact us": "skontaktuj się z nami",
  "Enter the minimum or expected number of people":
    "Wprowadź minimalną lub oczekiwaną liczbę osób",
  "Choose a city or location first to allow date and time filtering":
    "Najpierw wybierz miasto lub lokalizację, aby umożliwić filtrowanie według daty i godziny",
  "Clear start time": "Wyczyść czas rozpoczęcia",
  "Clear duration": "Wyczyść czas trwania",
  "Select a location to filter by date":
    "Wybierz lokalizację, aby filtrować według daty",
  "Checkout session expired": "Sesja płatności wygasła",
  "Your checkout session has expired. Please refresh your page.":
    "Twoja sesja płatności wygasła. Odśwież stronę.",
  "Refresh Page": "Odśwież stronę",
  "Order is being disputed": "Zamówienie jest kwestionowane",
  "Order was disputed": "Zamówienie zostało zakwestionowane",
  "Please add your membership number": "Proszę dodać numer członkostwa",
  "Please enter only ten digits": "Proszę wprowadzić tylko 10 cyfr",
  "Membership details": "Szczegóły członkostwa",
  "Member ID Barcode": "Kod kreskowy numeru członkostwa",
  "Confirm and Join Now": "Potwierdź i dołącz teraz",
  "Meeting rooms": "Sale konferencyjne",
  "Event spaces": "Przestrzenie eventowe",
  "Daily offices": "Biura codzienne",
  Category: "Kategoria",
  optional: "opcjonalnie",
  "Confirm and subscribe": "Potwierdź i zapisz się",
  "I agree to the terms of service": "Wyrażam zgodę na warunki usługi",
  "Thank you for your request. We will review the details and confirm availability shortly. This is a request to book, not a guaranteed reservation. You will receive a confirmation email at {email} once your booking is approved.":
    "Dziękujemy za Twoją prośbę. Przejrzyjemy szczegóły i potwierdzimy dostępność w krótkim czasie. Jest to prośba o rezerwację, nie gwarantowana rezerwacja. Otrzymasz e-mail z potwierdzeniem na adres {email} po potwierdzeniu rezerwacji.",
  "Thank you for your request. We will review the details and confirm availability shortly. This is a request to subscribe, not a guaranteed subscription. You will receive a confirmation email at {email} once your subscription is approved.":
    "Dziękujemy za Twoją prośbę. Przejrzyjemy szczegóły i potwierdzimy dostępność w krótkim czasie. Jest to prośba o subskrypcję, nie gwarantowana subskrypcja. Otrzymasz e-mail z potwierdzeniem na adres {email} po zatwierdzeniu subskrypcji.",
  "Request Submitted!": "Prośba została wysłana!",
  // Amenity management (English-only for v1; translations to follow)
  "Add amenity": "Add amenity",
  "Edit amenity": "Edit amenity",
  "Edit description": "Edit description",
  "Remove from library": "Remove from library",
  "Remove from library?": "Remove from library?",
  "Removing…": "Removing…",
  Remove: "Usuń",
  "Adding…": "Adding…",
  "Saving…": "Saving…",
  Add: "Add",
  "1. Pick an icon": "1. Pick an icon",
  "2. Describe it": "2. Describe it",
  "Search icons": "Search icons",
  "Search your library": "Search your library",
  "How would you describe this for customers?":
    "How would you describe this for customers?",
  "Aim for 25 characters or fewer so the label fits on one line.":
    "Aim for 25 characters or fewer so the label fits on one line.",
  "Over 25 characters — the label may wrap on desktop. Consider trimming.":
    "Over 25 characters — the label may wrap on desktop. Consider trimming.",
  "Over 40 characters — the label will wrap on every screen. Trim it down.":
    "Over 40 characters — the label will wrap on every screen. Trim it down.",
  Description: "Description",
  "Amenity added to your library.": "Amenity added to your library.",
  "Could not add amenity. Please try again.":
    "Could not add amenity. Please try again.",
  "Amenity updated.": "Amenity updated.",
  "Could not update amenity. Please try again.":
    "Could not update amenity. Please try again.",
  "No icons match your search.": "No icons match your search.",
  "Don't see what you need?": "Don't see what you need?",
  "Add to your library.": "Add to your library.",
  added: "added",
  "Amenity attached.": "Amenity attached.",
  "Could not attach. Please try again.": "Could not attach. Please try again.",
  "Your amenity library is empty. Add one to get started.":
    "Your amenity library is empty. Add one to get started.",
  "Add to your library": "Add to your library",
  "Build your amenity library": "Build your amenity library",
  "Pick amenities from our catalog and describe each one. Drag to reorder — customers see them in this order on every space and location.":
    "Pick amenities from our catalog and describe each one. Drag to reorder — customers see them in this order on every space and location.",
  "Pick from our icon catalog and describe each amenity in your own words.":
    "Pick from our icon catalog and describe each amenity in your own words.",
  "This change is visible to guests immediately.":
    "This change is visible to guests immediately.",
  "Could not save the new order.": "Could not save the new order.",
  "Amenity removed.": "Amenity removed.",
  "Could not remove. Please try again.": "Could not remove. Please try again.",
  "Could not detach amenity (missing identifier).":
    "Could not detach amenity (missing identifier).",
  "Could not detach.": "Could not detach.",
  "Could not detach amenity.": "Could not detach amenity.",
  "No location amenities added yet.": "No location amenities added yet.",
  Catalogs: "Catalogs",
  Catalog: "Catalog",
  "No catalogs yet": "No catalogs yet",
  "Your catalogs will appear here once they're set up. To add one, email help@flexspace.ai.":
    "Your catalogs will appear here once they're set up. To add one, email help@flexspace.ai.",
  "1 offering": "1 offering",
  "Catalog not found": "Catalog not found",
  "This catalog isn't available. It may have been renamed or removed.":
    "This catalog isn't available. It may have been renamed or removed.",
  "Back to Catalogs": "Back to Catalogs",
  "Your profile": "Your profile",
  "Follow us on LinkedIn": "Obserwuj nas na LinkedIn",
  Partner: "Partner",
  "Account type": "Account type",
  "White-label": "White-label",
  Teams: "Teams",
  "1 location": "1 location",
  "Sign out": "Sign out",
  "Your account": "Your account",
  Cancel: "Anuluj",
  Edit: "Edytuj",
  "Save changes": "Zapisz zmiany",
  "Profile updated.": "Zaktualizowano profil.",
  "Your full name": "Twoje imię i nazwisko",
  "Please enter your name.": "Podaj swoje imię i nazwisko.",
  "Couldn't save your changes. Please try again.":
    "Nie udało się zapisać zmian. Spróbuj ponownie.",
  "Unavailable on {days} — the add-on will skip that day.":
    "Niedostępne w {days} — dodatek pominie ten dzień.",
  "Unavailable on {days} — the add-on will skip those days.":
    "Niedostępne w {days} — dodatek pominie te dni.",
  "Removed {addOns} — no longer available for your booking.":
    "Usunięto {addOns} — niedostępne dla Twojej rezerwacji.",
  "Removed {addOns} — sold out for your booking.":
    "Usunięto {addOns} — brak miejsc dla Twojej rezerwacji.",
  "Removed {addOns} — sold out on {date}.":
    "Usunięto {addOns} — brak miejsc w dniu {date}.",
  "Removed {addOns} — sold out for a party of {guests} on {date}.":
    "Usunięto {addOns} — brak miejsc dla grupy {guests} osób w dniu {date}.",
  "Fully booked on {days} — the add-on will skip that day.":
    "Brak miejsc w {days} — dodatek pominie ten dzień.",
  "Fully booked on {days} — the add-on will skip those days.":
    "Brak miejsc w {days} — dodatek pominie te dni.",
  "Only {count} left": "Pozostało tylko {count}",
  Team: "Zespół",
  Role: "Rola",
  Admin: "Administrator",
  Standard: "Standardowy",
  Actions: "Akcje",
  "Add user": "Dodaj użytkownika",
  "Remove user": "Usuń użytkownika",
  Member: "Członek",
  member: "członek",
  members: "członkowie",
  admin: "administrator",
  admins: "administratorzy",
  "Team actions for {member}": "Działania zespołu dla {member}",
  "(you)": "(Ty)",
  "{email} · (you)": "{email} · (Ty)",
  "Reset password": "Zresetuj hasło",
  "Send invite": "Wyślij zaproszenie",
  "Send reset email": "Wyślij e-mail resetujący",
  "Sending…": "Wysyłanie…",
  "Try again": "Spróbuj ponownie",
  "We couldn't load our payment provider":
    "Nie udało się załadować naszego dostawcy płatności",
  "An ad blocker, privacy extension, or restricted network can block it. Allow this page, or try a different browser.":
    "Może go blokować blokada reklam, rozszerzenie chroniące prywatność lub ograniczona sieć. Zezwól tej stronie lub użyj innej przeglądarki.",
  "If the payment form doesn't appear, close this window and start your booking again.":
    "Jeśli formularz płatności się nie pojawi, zamknij to okno i rozpocznij rezerwację od nowa.",
  "Please add their name.": "Podaj imię i nazwisko.",
  "Please add a valid email.": "Podaj prawidłowy adres e-mail.",
  "Invite sent to {email}": "Zaproszenie wysłano na {email}",
  "Role updated.": "Rola zaktualizowana.",
  "User removed.": "Użytkownik usunięty.",
  "Password reset email sent.": "E-mail resetujący hasło został wysłany.",
  "Something went wrong. Please try again.":
    "Coś poszło nie tak. Spróbuj ponownie.",
  "Remove {name}": "Usuń {name}",
  "{count} {name}": "{count} {name}",
  "Remove {name}?": "Usunąć {name}?",
  "Remove this user?": "Usunąć tego użytkownika?",
  "This removes their access to this dashboard. Their account is kept and they can be re-added later.":
    "Spowoduje to odebranie dostępu do tego panelu. Konto zostanie zachowane i można je dodać ponownie później.",
  "You're removing yourself — you'll lose access immediately.":
    "Usuwasz siebie — natychmiast utracisz dostęp.",
  "Send a password reset email to {email}?":
    "Wysłać e-mail resetujący hasło na {email}?",
  "Change role to Admin": "Zmień rolę na Administrator",
  "Change role to Standard": "Zmień rolę na Standardowy",
  "Send password reset": "Wyślij resetowanie hasła",
  "Full dashboard access, except the Settings section.":
    "Pełny dostęp do panelu, z wyjątkiem sekcji Ustawienia.",
  "Everything a standard user can do, plus Settings — notifications and team management.":
    "Wszystko, co może zrobić użytkownik standardowy, a także Ustawienia: powiadomienia i zarządzanie zespołem.",
  "They'll receive an email invitation to set their password.":
    "Otrzymają e-mail z zaproszeniem do ustawienia hasła.",
  "Manage who can access the {partnerName} dashboard.":
    "Zarządzaj tym, kto ma dostęp do panelu {partnerName}.",
  "No team members yet": "Brak członków zespołu",
  "Search by name or email": "Szukaj według nazwiska lub adresu e-mail",
  "No members matched": "Brak pasujących członków",
  "No one on your team matches that search. Clear it to see everyone again.":
    "Nikt z Twojego zespołu nie pasuje do tego wyszukiwania. Wyczyść je, aby ponownie zobaczyć wszystkich.",
  "Matching {search}": "Pasujące do {search}",
  "Add a team member to give them access to this dashboard.":
    "Dodaj członka zespołu, aby dać mu dostęp do tego panelu.",
  Settings: "Ustawienia",
  "You don't have access to the catalog": "Nie masz dostępu do katalogu",
  "Ask one of your admins to grant you catalog access.":
    "Poproś jednego z administratorów o przyznanie dostępu do katalogu.",
  Orders: "Zamówienia",
  Campaigns: "Kampanie",
  "Create orders": "Tworzenie zamówień",
  "Cancel orders and refund": "Anulowanie zamówień i zwroty",
  "Accept or reject requests": "Akceptowanie lub odrzucanie próśb",
  "Open and edit the catalog": "Otwieranie i edycja katalogu",
  "Activate and deactivate products": "Aktywowanie i dezaktywowanie produktów",
  "Create and edit campaigns": "Tworzenie i edycja kampanii",
  "Book on behalf of a customer.": "Rezerwacja w imieniu klienta.",
  "Cancel an order or a booking and issue refunds.":
    "Anulowanie zamówienia lub rezerwacji i wykonywanie zwrotów.",
  "Decide requested orders and membership requests.":
    "Decydowanie o zamówieniach na prośbę i prośbach o członkostwo.",
  "See and change spaces, pricing, layouts, images and FAQ.":
    "Przeglądanie i zmiana przestrzeni, cen, układów, zdjęć i FAQ.",
  "Turn a space or membership on or off for booking.":
    "Włączanie lub wyłączanie przestrzeni lub członkostwa do rezerwacji.",
  "Make, edit, archive and label promotions.":
    "Tworzenie, edycja, archiwizowanie i oznaczanie promocji.",
  "Edit permissions": "Edytuj uprawnienia",
  "What {name} can do in this dashboard.": "Co {name} może robić w tym panelu.",
  "Save permissions": "Zapisz uprawnienia",
  Access: "Dostęp",
  "Full access": "Pełny dostęp",
  "All permissions": "Wszystkie uprawnienia",
  "{held} of {total} permissions": "{held} z {total} uprawnień",
  Permissions: "Uprawnienia",
  "They start with everything. Uncheck what they shouldn't do.":
    "Zaczynają z pełnym zestawem. Odznacz to, czego nie powinni robić.",
  "Permissions saved.": "Uprawnienia zapisane.",
  Owner: "Właściciel",
  owner: "właściciel",
  owners: "właścicieli",
  "Change role to Owner": "Zmień rolę na Właściciel",
  "Owners have full access. Change the role to limit it.":
    "Właściciele mają pełny dostęp. Zmień rolę, aby go ograniczyć.",
  "Everything an admin can do, always with every permission. Only an owner can add or change owners.":
    "Wszystko, co może administrator, zawsze ze wszystkimi uprawnieniami. Tylko właściciel może dodawać lub zmieniać właścicieli.",
  "You can only grant permissions you hold.":
    "Możesz przyznać tylko uprawnienia, które sam masz.",
  "Admin access required": "Wymagany dostęp administratora",
  "You need an admin role to manage this team. Ask one of your admins to update your role.":
    "Aby zarządzać tym zespołem, potrzebujesz roli administratora. Poproś administratora o zaktualizowanie Twojej roli.",
  "You need an admin role to view this page. Ask one of your admins to update your role.":
    "Aby wyświetlić tę stronę, potrzebujesz roli administratora. Poproś administratora o zaktualizowanie Twojej roli.",
  "We couldn't load these rooms.": "Nie udało się załadować tych sal.",
  "We couldn't load your team. Check your connection and try again.":
    "Nie udało się załadować zespołu. Sprawdź połączenie i spróbuj ponownie.",
  "Updating…": "Aktualizowanie…",
  "A booking made inside this window gets its reminder as soon as it's confirmed.":
    "Rezerwacja dokonana w tym oknie otrzyma przypomnienie od razu po potwierdzeniu.",
  "A nudge before the reservation starts. Because it's built at send time, anything time-sensitive you put here — an access code, say — is always the version you last saved.":
    "Przypomnienie przed rozpoczęciem rezerwacji. Ponieważ jest tworzone w momencie wysyłki, wszystko, co wrażliwe na czas — na przykład kod dostępu — zawsze będzie w ostatnio zapisanej wersji.",
  "Add product type": "Dodaj typ produktu",
  "Add teammate": "Dodaj współpracownika",
  "All changes saved": "Wszystkie zmiany zapisane",
  "All locations": "Wszystkie lokalizacje",
  "All notifications": "Wszystkie powiadomienia",
  "Also send a copy to your team": "Wyślij też kopię do swojego zespołu",
  "An invitation to buy another multi-pass, sent when a customer runs out. Turn it off if you run your own re-engagement emails — from HubSpot, for example.":
    "Zaproszenie do zakupu kolejnego multikarnetu, wysyłane gdy klientowi się skończy. Wyłącz je, jeśli wysyłasz własne e-maile ponownie angażujące — na przykład z HubSpota.",
  "Applies to": "Dotyczy",
  "Automated emails Flexspace sends your customers. Open one to change what it says, when it goes out, or turn it off.":
    "Automatyczne e-maile, które Flexspace wysyła Twoim klientom. Otwórz dowolny, aby zmienić treść, moment wysyłki lub go wyłączyć.",
  "Before the booking starts": "Przed rozpoczęciem rezerwacji",
  "Booking reminder": "Przypomnienie o rezerwacji",
  "Booking reminder saved.": "Przypomnienie o rezerwacji zapisane.",
  CC: "DW",
  Custom: "Dostosowane",
  Default: "Domyślne",
  "Every booking": "Każda rezerwacja",
  "Every confirmed booking gets this reminder.":
    "Każda potwierdzona rezerwacja otrzymuje to przypomnienie.",
  "Flexspace writes and sends this email — the exact copy is shown in the preview. Editing the wording here is coming; for now you can turn it off or CC your team.":
    "Flexspace pisze i wysyła ten e-mail — dokładna treść jest widoczna w podglądzie. Edycja treści tutaj pojawi się wkrótce; na razie możesz go wyłączyć lub dodać swój zespół do DW.",
  Insert: "Wstaw",
  "Leave this on your default and it follows every change you make there. A space here can still send its own on top.":
    "Jeśli pozostawisz wersję domyślną, będzie ona odzwierciedlać każdą zmianę wprowadzoną tam. Przestrzeń tutaj nadal może wysyłać własną.",
  "Merge fields are shown filled in with a sample booking: Priya Raman, Studio 2 at Mission Bay, 9:00 AM.":
    "Pola dynamiczne pokazane są wypełnione przykładową rezerwacją: Priya Raman, Studio 2 w Mission Bay, 9:00.",
  "Mission Bay": "Mission Bay",
  "Multi Day Pass 5 Pack": "Multi Day Pass 5 Pack",
  "Multi-pass top-up": "Doładowanie multikarnetu",
  "Multi-pass top-up saved.": "Doładowanie multikarnetu zapisane.",
  "No one CC'd": "Nikogo w DW",
  "No product types match": "Brak typów produktu pasujących do",
  "No reminder goes out until you set one up.":
    "Żadne przypomnienie nie zostanie wysłane, dopóki go nie skonfigurujesz.",
  "Not set": "Nie ustawiono",
  Notifications: "Powiadomienia",
  Off: "Wył.",
  "Off sends nothing here, whatever the levels above say.":
    "Wyłączone nie wysyła tu nic, niezależnie od poziomów nadrzędnych.",
  "Off stops the reminder everywhere.":
    "Wyłączone zatrzymuje przypomnienie wszędzie.",
  On: "Wł.",
  "Only bookings of certain product types":
    "Tylko rezerwacje wybranych typów produktu",
  "Only bookings of the selected product types get this reminder.":
    "Tylko rezerwacje wybranych typów produktu otrzymują to przypomnienie.",
  Override: "Dostosuj",
  "Payment failed": "Płatność nieudana",
  'Pick at least one product type, or switch back to "Every booking".':
    'Wybierz co najmniej jeden typ produktu albo wróć do "Każda rezerwacja".',
  Preview: "Podgląd",
  "Rebuilt at send time — edits reach every future email":
    "Tworzony w chwili wysyłki — zmiany trafiają do każdego przyszłego e-maila",
  Reminder: "Przypomnienie",
  "Reminder email": "E-mail z przypomnieniem",
  "Reminder reset — this level inherits again.":
    "Przypomnienie przywrócone — ten poziom znów dziedziczy.",
  "Reminders cascade: your default applies everywhere. A location can send its own, and a space can send its own on top of that.":
    "Przypomnienia dziedziczą się: Twoja wersja domyślna obowiązuje wszędzie. Lokalizacja może wysyłać własną, a przestrzeń własną ponad nią.",
  "Remove override": "Usuń dostosowanie",
  "Reset to defaults": "Przywróć wartości domyślne",
  "Sample booking": "Przykładowa rezerwacja",
  "Save reminder": "Zapisz przypomnienie",
  "Search locations": "Szukaj lokalizacji",
  "Search product types…": "Szukaj typów produktu…",
  "Search spaces": "Szukaj przestrzeni",
  "See reminder": "Zobacz przypomnienie",
  "Sends its own version — every space here inherits it.":
    "Wysyła własną wersję — każda przestrzeń tutaj ją dziedziczy.",
  "Sent the moment the last pass in a bundle is used — timing can't be changed.":
    "Wysyłany w chwili wykorzystania ostatniego wejścia z pakietu — momentu nie można zmienić.",
  "Set up reminder": "Skonfiguruj przypomnienie",
  "Shown with a sample customer and pass. The wording is what actually goes out; the button and photo take your own branding.":
    "Pokazany z przykładowym klientem i karnetem. Treść jest dokładnie tą, która zostanie wysłana; przycisk i zdjęcie przyjmują Twoją markę.",
  Space: "Przestrzeń",
  "Spaces at": "Przestrzenie w",
  Subject: "Temat",
  "The reminder bookings of this space get, inheriting from its location.":
    "Przypomnienie, które otrzymują rezerwacje tej przestrzeni, dziedziczone z jej lokalizacji.",
  "The reminder every booking at this location gets, inheriting from your default.":
    "Przypomnienie, które otrzymuje każda rezerwacja w tej lokalizacji, dziedziczone z Twojej wersji domyślnej.",
  "The reminder every booking gets before it starts, unless a location or a space sends its own.":
    "Przypomnienie, które otrzymuje każda rezerwacja przed rozpoczęciem, chyba że lokalizacja lub przestrzeń wysyła własne.",
  "They're CC'd on every copy of this email that goes out.":
    "Otrzymują kopię (DW) każdego wysyłanego e-maila.",
  "This email is off, so nobody is receiving it. Your settings are saved and will apply if you turn it back on.":
    "Ten e-mail jest wyłączony, więc nikt go nie otrzymuje. Twoje ustawienia są zapisane i zaczną obowiązywać po ponownym włączeniu.",
  "This is the most specific level: a reminder set here wins over its location and your default.":
    "To najbardziej szczegółowy poziom: przypomnienie ustawione tutaj ma pierwszeństwo nad lokalizacją i Twoją wersją domyślną.",
  "This location": "Ta lokalizacja",
  "This space": "Ta przestrzeń",
  To: "Do",
  "Turn this email on or off": "Włącz lub wyłącz ten e-mail",
  "Turn this reminder on or off": "Włącz lub wyłącz to przypomnienie",
  "Unsaved changes": "Niezapisane zmiany",
  Using: "Używa",
  "Using default": "Używa domyślnej",
  "Using your default — every space here inherits it.":
    "Używa Twojej wersji domyślnej — każda przestrzeń tutaj ją dziedziczy.",
  "We couldn't load your booking reminder. Check your connection and try again.":
    "Nie mogliśmy wczytać Twojego przypomnienia o rezerwacji. Sprawdź połączenie i spróbuj ponownie.",
  "We couldn't reset this reminder. Try again.":
    "Nie mogliśmy przywrócić tego przypomnienia. Spróbuj ponownie.",
  "We couldn't save this reminder. Try again.":
    "Nie mogliśmy zapisać tego przypomnienia. Spróbuj ponownie.",
  "What your customers get": "Co otrzymują Twoi klienci",
  "When a customer uses their last day pass":
    "Gdy klient wykorzysta swój ostatni karnet dzienny",
  "When it sends": "Kiedy jest wysyłany",
  "Yours to configure": "Do Twojej konfiguracji",
  custom: "dostosowanych",
  "custom version": "dostosowana wersja",
  "custom versions": "dostosowanych wersji",
  "hours before the booking starts": "godz. przed rozpoczęciem rezerwacji",
  location: "lokalizacja",
  of: "z",
  "reminder settings": "ustawienia przypomnienia",
  space: "przestrzeń",
  spaces: "przestrzenie",
  "your default": "Twoją wersję domyślną",
  "Space layouts": "Układy przestrzeni",
  "See all space layouts": "Zobacz wszystkie układy",
  "All space layouts": "Wszystkie układy przestrzeni",
  Layout: "Układ",
  "Select layout": "Wybierz układ",
  "Number of people": "Liczba osób",
  "Our meeting rooms fit up to {max} people.":
    "Nasze sale konferencyjne mieszczą do {max} osób.",

  // Staff order confirmation email (Settings -> Notifications)
  "Staff order confirmation": "Potwierdzenie zamówienia dla zespołu",
  "When an order is confirmed": "Gdy zamówienie zostanie potwierdzone",
  "Who on your team hears about a confirmed order, and what they read. Set it once for everywhere, then let a location, a product type or a single space differ where it needs to.":
    "Kto w Twoim zespole dowiaduje się o potwierdzonym zamówieniu i co czyta. Ustaw to raz dla wszystkiego, a potem pozwól lokalizacji, typowi produktu lub pojedynczej przestrzeni różnić się tam, gdzie trzeba.",
  "Who on your team hears about a confirmed order, and what they read. These apply to every location and space unless a more specific level sets its own.":
    "Kto w Twoim zespole dowiaduje się o potwierdzonym zamówieniu i co czyta. Dotyczy każdej lokalizacji i przestrzeni, chyba że bardziej szczegółowy poziom ustawi własne.",
  "This email cascades: your defaults apply everywhere. A location can set its own, a product type at that location can set its own, and a single space can set its own on top of that.":
    "Ten e-mail działa kaskadowo: Twoje wartości domyślne obowiązują wszędzie. Lokalizacja może ustawić własne, typ produktu w tej lokalizacji może ustawić własne, a pojedyncza przestrzeń może ustawić własne ponad tym.",
  "can still set its own on top.": "nadal może ustawić własne ponad tym.",
  "Orders of this product type at this location only, inheriting from the location and your defaults.":
    "Tylko zamówienia tego typu produktu w tej lokalizacji, dziedziczone z lokalizacji i Twoich wartości domyślnych.",
  "Anything custom here wins over":
    "Wszystko ustawione tutaj ma pierwszeństwo przed",
  "and your defaults. A single space can still set its own on top.":
    "i Twoimi wartościami domyślnymi. Pojedyncza przestrzeń nadal może ustawić własne ponad tym.",
  "This space only, inheriting from everything above it.":
    "Tylko ta przestrzeń, dziedzicząca ze wszystkiego powyżej.",
  "This is the most specific level: anything custom here wins over every other level.":
    "To najbardziej szczegółowy poziom: wszystko ustawione tutaj ma pierwszeństwo przed każdym innym poziomem.",
  Recipients: "Odbiorcy",
  Sender: "Nadawca",
  "Staff instructions": "Instrukcje dla zespołu",
  "Applies to every order unless a more specific level sets its own list. Overriding replaces every recipient — lists don't merge across levels.":
    "Dotyczy każdego zamówienia, chyba że bardziej szczegółowy poziom ustawi własną listę. Nadpisanie zastępuje wszystkich odbiorców — listy nie łączą się między poziomami.",
  "Overriding replaces the inherited list in full — lists don't merge across levels.":
    "Nadpisanie w całości zastępuje odziedziczoną listę — listy nie łączą się między poziomami.",
  "We couldn't load this email's settings. Check your connection and try again.":
    "Nie udało się wczytać ustawień tego e-maila. Sprawdź połączenie i spróbuj ponownie.",
  "Only an admin can change this email. You can look up any level here.":
    "Tylko administrator może zmienić ten e-mail. Tutaj możesz sprawdzić dowolny poziom.",
  Defaults: "Domyślne",
  "Product type": "Typ produktu",
  "Product types at": "Typy produktów w",
  "Spaces using this product type":
    "Przestrzenie korzystające z tego typu produktu",
  "Sits between the location and a single space. A meeting room and a day pass at the same address rarely need the same people notified.":
    "Znajduje się między lokalizacją a pojedynczą przestrzenią. Sala konferencyjna i karnet dzienny pod tym samym adresem rzadko wymagają powiadomienia tych samych osób.",
  "No product type": "Brak typu produktu",
  "No one": "Nikt",
  "no one": "nikt",
  Open: "Otwórz",
  "Reset all to defaults": "Przywróć wszystko do wartości domyślnych",
  "Reset to": "Przywróć do",
  "reset to defaults.": "przywrócono do wartości domyślnych.",
  "Couldn't reset this level. Please try again.":
    "Nie udało się przywrócić tego poziomu. Spróbuj ponownie.",
  "Actions for": "Akcje dla",
  "Using default · from": "Używa wartości domyślnej · z",
  "saved.": "zapisano.",
  "Sent to": "Wysyłane do",
  "Everyone here is on the To line. At least one is required.":
    "Wszyscy tutaj trafiają do pola Do. Wymagana jest co najmniej jedna osoba.",
  "Reply-to": "Odpowiedz do",
  "Where a reply lands. Optional — leave it empty and replies go to the From address.":
    "Gdzie trafia odpowiedź. Opcjonalne — pozostaw puste, a odpowiedzi trafią na adres nadawcy.",
  "From name": "Nazwa nadawcy",
  "The name your team sees in their inbox.":
    "Nazwa, którą Twój zespół widzi w skrzynce odbiorczej.",
  "Merge fields are filled in when the order is confirmed.":
    "Pola scalania są uzupełniane po potwierdzeniu zamówienia.",
  Title: "Tytuł",
  "The heading inside the email.": "Nagłówek wewnątrz e-maila.",
  "Note to your team": "Notatka dla zespołu",
  "Rebuilt at send time, so a change reaches every future order.":
    "Tworzone w chwili wysyłki, więc zmiana obejmie każde przyszłe zamówienie.",
  Attachment: "Załącznik",
  "One PDF, sent with every copy of this email.":
    "Jeden plik PDF, wysyłany z każdą kopią tego e-maila.",
  "Upload PDF": "Prześlij PDF",
  Replace: "Zastąp",
  "Uploading…": "Przesyłanie…",
  "Add recipient": "Dodaj odbiorcę",
  "Add reply-to": "Dodaj odpowiedz do",
  "Add reply-to address": "Dodaj adres odpowiedzi",
  "Add 1 recipient": "Dodaj 1 odbiorcę",
  recipient: "odbiorca",
  recipients: "odbiorców",
  override: "nadpisanie",
  overrides: "nadpisania",
  "Add a recipient to continue.": "Dodaj odbiorcę, aby kontynuować.",
  "At least one recipient is required, or reset this level so it falls back to":
    "Wymagany jest co najmniej jeden odbiorca albo przywróć ten poziom, aby wrócił do",
  "At least one recipient is required — nothing sends without one.":
    "Wymagany jest co najmniej jeden odbiorca — bez niego nic nie zostanie wysłane.",
  "Anyone here receives the full order details, including the guest's name and email.":
    "Każdy tutaj otrzymuje pełne dane zamówienia, w tym imię i e-mail gościa.",
  "Your team": "Twój zespół",
  "Already added": "Już dodano",
  "Someone else": "Ktoś inny",
  Address: "Adres",
  "is not a valid email address.": "nie jest prawidłowym adresem e-mail.",
  "is already on the list.": "jest już na liście.",
  "Send test email": "Wyślij e-mail testowy",
  "Send test": "Wyślij test",
  "Send to": "Wyślij do",
  "What will send": "Co zostanie wysłane",
  "We'll send one copy of the": "Wyślemy jedną kopię wersji",
  "version, filled in with a sample order. Your real recipients are not contacted.":
    ", wypełnionej przykładowym zamówieniem. Twoi prawdziwi odbiorcy nie są powiadamiani.",
  "Test sent to": "Test wysłany do",
  "Couldn't send the test. Please try again.":
    "Nie udało się wysłać testu. Spróbuj ponownie.",
  "your defaults": "Twoje wartości domyślne",
  "reset — this level inherits again.":
    "przywrócono — ten poziom znów dziedziczy.",
  "Staff email": "E-mail zespołu",
  "See recipients": "Zobacz odbiorców",
  "can still set its own on top — a meeting room and a day pass at the same address rarely need the same people notified.":
    "nadal może ustawić własne ponad tym — sala konferencyjna i karnet dzienny pod tym samym adresem rzadko wymagają powiadomienia tych samych osób.",
  "Search product types": "Szukaj typów produktów",
  "product type": "typ produktu",
  "Set up": "Skonfiguruj",
  "Using defaults": "Używa wartości domyślnych",
  "Staff order confirmation saved.":
    "Zapisano potwierdzenie zamówienia dla zespołu.",
  "This product type": "Ten typ produktu",
  "No one is notified until you name someone.":
    "Nikt nie zostanie powiadomiony, dopóki nikogo nie wskażesz.",
  "Merge fields are shown filled in with a sample order: Priya Raman, Studio 2 at Mission Bay, July 30.":
    "Pola scalania pokazano wypełnione przykładowym zamówieniem: Priya Raman, Studio 2 w Mission Bay, 30 lipca.",
  "One step more specific than this location: applies to orders of that type here, and a single space can still override it.":
    "O jeden poziom bardziej szczegółowe niż ta lokalizacja: dotyczy zamówień tego typu tutaj, a pojedyncza przestrzeń nadal może to nadpisać.",
  "The most specific level: a space overrides its product type and this location.":
    "Najbardziej szczegółowy poziom: przestrzeń ma pierwszeństwo przed swoim typem produktu i tą lokalizacją.",
  "The most specific level: a space overrides this product type and its location.":
    "Najbardziej szczegółowy poziom: przestrzeń ma pierwszeństwo przed tym typem produktu i swoją lokalizacją.",
  "This booking link looks incomplete":
    "Ten link do rezerwacji wygląda na niekompletny",
  "Some email apps shorten long links. Please open the link from your confirmation email again, or contact the venue if it keeps happening.":
    "Niektóre aplikacje pocztowe skracają długie linki. Otwórz ponownie link z e-maila z potwierdzeniem lub skontaktuj się z obiektem, jeśli problem się powtarza.",
  "Guest order confirmation": "Potwierdzenie zamówienia dla gościa",
  "When a customer books": "Gdy klient rezerwuje",
  "The confirmation every customer gets when they book — the welcome note, directions and help section. Set it once for everywhere, then let a location, a product type or a single space differ where it needs to.":
    "Potwierdzenie, które otrzymuje każdy klient przy rezerwacji — wiadomość powitalna, dojazd i sekcja pomocy. Ustaw raz dla wszystkich miejsc, a potem pozwól lokalizacji, typowi produktu lub pojedynczej przestrzeni różnić się tam, gdzie trzeba.",
  "What your customers read when a booking is confirmed — the subject, the welcome note, directions and help section. These apply everywhere unless a more specific level sets its own. Every confirmed booking sends one: this email can't be turned off.":
    "To, co czytają Twoi klienci po potwierdzeniu rezerwacji — temat, wiadomość powitalna, dojazd i sekcja pomocy. Obowiązują wszędzie, chyba że bardziej szczegółowy poziom ustawi własne. Każda potwierdzona rezerwacja wysyła jedno: tego e-maila nie można wyłączyć.",
  "The booking confirmation for every order at this location, inheriting from your defaults.":
    "Potwierdzenie rezerwacji dla każdego zamówienia w tej lokalizacji, dziedziczące z ustawień domyślnych.",
  "Anything left on its default here follows your defaults. What you set here also backs this location's add-on and invite confirmation emails. A product type or a single space at":
    "Wszystko, co pozostanie tu na ustawieniu domyślnym, podąża za Twoimi ustawieniami domyślnymi. To, co tu ustawisz, jest też podstawą e-maili potwierdzających dodatki i zaproszenia w tej lokalizacji. Typ produktu lub pojedyncza przestrzeń w",
  "Bookings of this product type at this location only, inheriting from the location and your defaults.":
    "Tylko rezerwacje tego typu produktu w tej lokalizacji, dziedziczące z lokalizacji i ustawień domyślnych.",
  "Customer email": "E-mail klienta",
  "See what sends": "Zobacz, co jest wysyłane",
  "Guest order confirmation saved.":
    "Potwierdzenie zamówienia dla gościa zapisane.",
  "Subject & title": "Temat i tytuł",
  "Email content": "Treść wiadomości",
  "Reply-to & attachment": "Adres odpowiedzi i załącznik",
  "The subject and title can carry:": "Temat i tytuł mogą zawierać:",
  "Each section falls back to our standard copy when left empty — the preview shows exactly what sends.":
    "Każda sekcja wraca do naszej standardowej treści, gdy pozostanie pusta — podgląd pokazuje dokładnie, co zostanie wysłane.",
  "Our standard subject": "Nasz standardowy temat",
  "welcome note": "wiadomość powitalna",
  directions: "dojazd",
  "help section": "sekcja pomocy",
  "Every section sends our standard copy.":
    "Wszystkie sekcje wysyłają naszą standardową treść.",
  "Custom copy:": "Treść niestandardowa:",
  "Welcome note": "Wiadomość powitalna",
  "Help section": "Sekcja pomocy",
  "Merge fields fill in when the booking is confirmed. Empty sends our standard subject.":
    "Pola scalane wypełniają się, gdy rezerwacja zostanie potwierdzona. Puste pole oznacza nasz standardowy temat.",
  "The headline inside the email. Empty sends our standard headline.":
    "Nagłówek wewnątrz wiadomości. Puste pole oznacza nasz standardowy nagłówek.",
  "Opens the email, above the booking details. Empty sends our standard thank-you.":
    "Otwiera wiadomość, nad szczegółami rezerwacji. Puste pole oznacza nasze standardowe podziękowanie.",
  "Under the email's Directions heading, next to the map link. Empty sends the location's address line.":
    "Pod nagłówkiem dojazdu w wiadomości, obok linku do mapy. Puste pole oznacza adres lokalizacji.",
  "Closes the email. The booking's cancellation policy always sends beneath it, so there is no need to insert it. Empty sends our standard invitation to reply.":
    "Zamyka wiadomość. Polityka anulowania rezerwacji zawsze jest wysyłana poniżej, więc nie trzeba jej wstawiać. Puste pole wysyła naszą standardową zachętę do odpowiedzi.",
  "Where a customer's reply lands. Empty sends replies to the From address.":
    "Dokąd trafia odpowiedź klienta. Puste pole kieruje odpowiedzi na adres nadawcy.",
  "The name customers see in their inbox.":
    "Nazwa, którą klienci widzą w swojej skrzynce.",
  "One PDF, sent with every confirmation.":
    "Jeden plik PDF wysyłany z każdym potwierdzeniem.",
  "Opening hours": "Godziny otwarcia",
  "The location's opening hours are listed here.":
    "Tutaj wyświetlane są godziny otwarcia lokalizacji.",
  "Our standard help copy: an invitation to reply to this email.":
    "Nasz standardowy tekst pomocy: zachęta do odpowiedzi na tę wiadomość.",
  "This booking's cancellation policy is stated here. It is worked out per booking when the email sends, so it can't be edited.":
    "Tutaj podana jest polityka anulowania tej rezerwacji. Jest ustalana dla każdej rezerwacji w momencie wysyłki wiadomości, więc nie można jej edytować.",
  "Merge fields are shown filled in with a sample booking: Priya Raman, Studio 2 at Mission Bay, July 30. The preview shows what actually sends — including inherited and standard copy you haven't overridden.":
    "Pola scalane są wypełnione przykładową rezerwacją: Priya Raman, Studio 2 w Mission Bay, 30 lipca. Podgląd pokazuje, co faktycznie zostanie wysłane — łącznie z odziedziczoną i standardową treścią, której nie nadpisano.",
  "If a product type or space overrides this copy for that booking, the email shows the version that actually sent.":
    "Jeśli typ produktu lub przestrzeń nadpisuje tę treść dla tej rezerwacji, wiadomość pokaże wersję, która faktycznie została wysłana.",
  "We'll re-send the confirmation from one of your recent bookings — the real email, exactly as that customer received it. It carries that booking's real details, so send it somewhere you'd be comfortable those details going.":
    "Wyślemy ponownie potwierdzenie jednej z Twoich ostatnich rezerwacji — prawdziwą wiadomość, dokładnie taką, jaką otrzymał ten klient. Zawiera prawdziwe dane tej rezerwacji, więc wyślij ją tam, gdzie te dane mogą trafić.",
  "only the address above": "tylko adres powyżej",
  // Recurring bookings — the storefront Repeat control
  "These dates are no longer available: {dates}. Choose another time, or turn Repeat off.":
    "Te terminy nie są już dostępne: {dates}. Wybierz inną godzinę lub wyłącz powtarzanie.",
  "Every {weekday}": "Co tydzień w {weekday}",
  "Every {interval} weeks on {weekday}": "Co {interval} tygodnie w {weekday}",
  "{span} · {count} bookings": "{span} · {count} rezerwacji",
  "Your bookings": "Twoje rezerwacje",
  "{date} fell on your pattern but was already taken. It was left out of the recurring booking and was not charged.":
    "{date} przypadał na Twój schemat, ale był już zajęty. Został pominięty w rezerwacji cyklicznej i nie został naliczony.",
  "{dates} fell on your pattern but were already taken. They were left out of the recurring booking and were not charged.":
    "{dates} przypadały na Twój schemat, ale były już zajęte. Zostały pominięte w rezerwacji cyklicznej i nie zostały naliczone.",
  "Thank you for booking with us. A confirmation email covering all {count} bookings has been sent to {email}. We are looking forward to seeing you soon.":
    "Dziękujemy za rezerwację. Wiadomość z potwierdzeniem obejmująca wszystkie {count} rezerwacje została wysłana na {email}. Do zobaczenia wkrótce.",
  "Not refundable. A single date can be cancelled to free the room, but is not refunded.":
    "Bez zwrotu. Pojedynczą datę można anulować, aby zwolnić salę, ale nie podlega ona zwrotowi.",
  "Refundable in full until {deadline}. After that, a single date can be cancelled to free the room, but is not refunded.":
    "Pełny zwrot przysługuje do {deadline}. Później pojedynczą datę można anulować, aby zwolnić salę, ale nie podlega ona zwrotowi.",
  "Charged once for the whole recurring booking.":
    "Naliczana raz za całą rezerwację cykliczną.",
  "Choose a date and time to repeat this booking.":
    "Wybierz datę i godzinę, aby powtarzać tę rezerwację.",
  "Choose a date to repeat this booking.":
    "Wybierz datę, aby powtarzać tę rezerwację.",
  "Repeat this booking": "Powtarzaj tę rezerwację",
  "Same room and time, every week": "Ta sama sala i godzina, co tydzień",
  "Same room and time, every {weekday}":
    "Ta sama sala i godzina, każdy {weekday}",
  Weekly: "Co tydzień",
  "Every 2 weeks": "Co 2 tygodnie",
  "Every 3 weeks": "Co 3 tygodnie",
  "Every 4 weeks": "Co 4 tygodnie",
  "location closed": "lokalizacja zamknięta",
  "already booked": "już zarezerwowane",
  "too soon to book": "za wcześnie na rezerwację",
  "too short for this room": "za krótko dla tej sali",
  unavailable: "niedostępne",
  Unavailable: "Niedostępne",
  "{count} booking": "{count} rezerwacja",
  "{count} bookings": "{count} rezerwacji",
  "Shortened to {count} bookings — a recurring booking has to finish inside the booking window, which ends {date}.":
    "Skrócono do {count} rezerwacji — rezerwacja cykliczna musi zakończyć się w oknie rezerwacji, które kończy się {date}.",
  "{count} bookings · {first} – {last}":
    "{count} rezerwacji · {first} – {last}",
  "Prices confirmed on Save": "Ceny potwierdzane po zapisaniu",
  "{count} unavailable date skipped · prices confirmed on Save":
    "Pominięto {count} niedostępną datę · ceny potwierdzane po zapisaniu",
  "{count} unavailable dates skipped · prices confirmed on Save":
    "Pominięto {count} niedostępnych dat · ceny potwierdzane po zapisaniu",
  "Repeats {preset} · {count} bookings through {last}":
    "Powtarza się {preset} · {count} rezerwacji do {last}",
  "{first} through {last}": "Od {first} do {last}",
  "Every date on this pattern is available.":
    "Wszystkie daty w tym schemacie są dostępne.",
  "1 date on this pattern is unavailable and not charged: {list}.":
    "1 data w tym schemacie jest niedostępna i nie jest naliczana: {list}.",
  "{count} dates on this pattern are unavailable and not charged: {list}.":
    "{count} dat w tym schemacie jest niedostępnych i nie są naliczane: {list}.",
  "After discounts": "Po rabatach",
  "Your recurring booking": "Twoja rezerwacja cykliczna",
  // Manage-order page — the customer's own view of a booking
  "This booking could not be loaded. Please try again, or contact the venue.":
    "Nie udało się wczytać tej rezerwacji. Spróbuj ponownie lub skontaktuj się z obiektem.",
  "1 guest": "1 gość",
  "{count} guests": "{count} gości",
  "This date could not be cancelled.": "Nie udało się anulować tego terminu.",
  "The booking could not be cancelled.": "Nie udało się anulować rezerwacji.",
  "This page is for recurring bookings. Your booking is on its confirmation page.":
    "Ta strona dotyczy rezerwacji cyklicznych. Twoja rezerwacja znajduje się na stronie potwierdzenia.",
  "Open confirmation page": "Otwórz stronę potwierdzenia",
  "Cancelled on {date}, before the first booking. Every one of the {count} dates was cancelled and {refund} was refunded to your payment method.":
    "Anulowano {date}, przed pierwszą rezerwacją. Każda z {count} dat została anulowana, a {refund} zwrócono na Twoją metodę płatności.",
  "1 booking cancelled": "1 rezerwacja anulowana",
  "Confirmation {code}": "Potwierdzenie {code}",
  "Booked {date}": "Zarezerwowano {date}",
  "Next booking": "Następna rezerwacja",
  "Your booking": "Twoja rezerwacja",
  "Cancelled recurring booking": "Anulowana rezerwacja cykliczna",
  "Cancelled booking": "Anulowana rezerwacja",
  "No bookings left": "Brak pozostałych rezerwacji",
  "{completed} of {total} bookings completed":
    "{completed} z {total} rezerwacji zakończonych",
  "{done} · booking {next} is next": "{done} · następna jest rezerwacja {next}",
  "Add recurring booking to calendar":
    "Dodaj rezerwację cykliczną do kalendarza",
  "Add to calendar": "Dodaj do kalendarza",
  "Get directions": "Wskazówki dojazdu",
  "Book this again": "Zarezerwuj to ponownie",
  "Book this room again": "Zarezerwuj tę salę ponownie",
  "This recurring booking was cancelled":
    "Ta rezerwacja cykliczna została anulowana",
  "This booking was cancelled": "Ta rezerwacja została anulowana",
  "Cancelled on {date}. {refund} was refunded to your payment method.":
    "Anulowano {date}. {refund} zwrócono na Twoją metodę płatności.",
  "Cancelled on {date}. No refund was issued.":
    "Anulowano {date}. Nie wydano zwrotu środków.",
  "No payment was taken online for this booking, so there's nothing to refund. Cancelling frees the room for someone else.":
    "Za tę rezerwację nie pobrano płatności online, więc nie ma czego zwracać. Anulowanie zwalnia salę dla kogoś innego.",
  "The room will be freed for someone else. No payment was taken online for this booking, so there's nothing to refund.":
    "Sala zostanie zwolniona dla kogoś innego. Za tę rezerwację nie pobrano płatności online, więc nie ma czego zwracać.",
  "Cancelled on {date}. No payment was taken online for this booking, so nothing was refunded.":
    "Anulowano {date}. Za tę rezerwację nie pobrano płatności online, więc nic nie zostało zwrócone.",
  Schedule: "Harmonogram",
  "{count} bookings cancelled": "{count} rezerwacji anulowanych",
  "{completed} completed · {cancelled} cancelled · {upcoming} upcoming":
    "{completed} zakończonych · {cancelled} anulowanych · {upcoming} nadchodzących",
  Upcoming: "Nadchodząca",
  Completed: "Zakończona",
  Cancelled: "Anulowana",
  "Cancel this date?": "Anulować tę datę?",
  "{date} will be freed for someone else, and the rest of your recurring booking stays exactly as it is.":
    "{date} zostanie zwolniony dla kogoś innego, a reszta Twojej rezerwacji cyklicznej pozostaje bez zmian.",
  "This date is not refunded. Your total stays {total}.":
    "Ta data nie podlega zwrotowi. Twoja suma pozostaje {total}.",
  "Cancel this date": "Anuluj tę datę",
  "Keep this date": "Zachowaj tę datę",
  "Cancelling this booking": "Anulowanie tej rezerwacji",
  "Dates can be cancelled one at a time but are not refunded. This recurring booking is not refundable.":
    "Daty można anulować pojedynczo, ale nie podlegają zwrotowi. Ta rezerwacja cykliczna nie podlega zwrotowi.",
  "Cancel the whole recurring booking for a full refund until {deadline}. After that, dates can be cancelled one at a time but are not refunded.":
    "Anuluj całą rezerwację cykliczną z pełnym zwrotem do {deadline}. Później daty można anulować pojedynczo, ale bez zwrotu.",
  "Dates can be cancelled but are not refunded. The recurring booking was refundable in full until {deadline}.":
    "Daty można anulować, ale nie podlegają zwrotowi. Rezerwacja cykliczna podlegała pełnemu zwrotowi do {deadline}.",
  "Cancel all upcoming": "Anuluj wszystkie nadchodzące",
  "Cancel booking": "Anuluj rezerwację",
  "Cancel this recurring booking?": "Anulować tę rezerwację cykliczną?",
  "All {count} upcoming dates will be cancelled and the rooms freed. {refund} is refunded to your payment method. Refunds take 5–10 business days to appear.":
    "Wszystkie {count} nadchodzące daty zostaną anulowane, a sale zwolnione. {refund} zostanie zwrócone na Twoją metodę płatności. Zwroty pojawiają się w ciągu 5–10 dni roboczych.",
  "All 1 upcoming date will be cancelled and the rooms freed. {refund} is refunded to your payment method. Refunds take 5–10 business days to appear.":
    "1 nadchodząca data zostanie anulowana, a sala zwolniona. {refund} zostanie zwrócone na Twoją metodę płatności. Zwroty pojawiają się w ciągu 5–10 dni roboczych.",
  "Cancel and refund": "Anuluj i zwróć",
  "Keep booking": "Zachowaj rezerwację",
  "This recurring booking can no longer be refunded":
    "Ta rezerwacja cykliczna nie podlega już zwrotowi",
  "A recurring booking is refundable in full until {deadline}, which has passed. You can still cancel the {count} upcoming dates one at a time, which frees the room on those dates.":
    "Rezerwacja cykliczna podlega pełnemu zwrotowi do {deadline}, a ten termin minął. Nadal możesz anulować {count} nadchodzące daty pojedynczo, co zwalnia salę w tych dniach.",
  "A recurring booking is refundable in full until {deadline}, which has passed. You can still cancel the 1 upcoming date one at a time, which frees the room on those dates.":
    "Rezerwacja cykliczna podlega pełnemu zwrotowi do {deadline}, a ten termin minął. Nadal możesz anulować 1 nadchodzącą datę, co zwalnia salę tego dnia.",
  "This recurring booking is not refundable. You can still cancel the {count} upcoming dates one at a time, which frees the room on those dates.":
    "Ta rezerwacja cykliczna nie podlega zwrotowi. Nadal możesz anulować {count} nadchodzące daty pojedynczo, co zwalnia salę w tych dniach.",
  "This recurring booking is not refundable. You can still cancel the 1 upcoming date one at a time, which frees the room on those dates.":
    "Ta rezerwacja cykliczna nie podlega zwrotowi. Nadal możesz anulować 1 nadchodzącą datę, co zwalnia salę tego dnia.",
  "Cancelled dates are not refunded. To ask for an exception, talk with the space directly.":
    "Anulowane daty nie podlegają zwrotowi. Aby poprosić o wyjątek, skontaktuj się bezpośrednio z obiektem.",
  "Back to booking": "Wróć do rezerwacji",
  "Service Fee": "Opłata serwisowa",
  Tax: "Podatek",
  "Refunded {date}": "Zwrócono {date}",
  "Balance ({currency})": "Saldo ({currency})",
  "Total ({currency})": "Razem ({currency})",
  "Billed to {address}": "Faktura na {address}",
  // The single booking's own page — its duration and its cancellation dialog
  "{count} hours": "{count} godzin",
  "{count} days": "{count} dni",
  "This booking is not refundable and can't be cancelled online. Please contact the venue if your plans change.":
    "Ta rezerwacja nie podlega zwrotowi i nie można jej anulować online. Jeśli Twoje plany się zmienią, skontaktuj się z obiektem.",
  "The cancellation window for this booking has closed, so it can no longer be cancelled online. Please contact the venue if your plans change.":
    "Termin anulowania tej rezerwacji minął, więc nie można jej już anulować online. Jeśli Twoje plany się zmienią, skontaktuj się z obiektem.",
  "This booking can't be cancelled online. Please contact the venue if your plans change.":
    "Tej rezerwacji nie można anulować online. Jeśli Twoje plany się zmienią, skontaktuj się z obiektem.",
  "This booking is not refundable. Cancelling frees the room for someone else but returns nothing.":
    "Ta rezerwacja nie podlega zwrotowi. Anulowanie zwalnia salę dla kogoś innego, ale nic nie zostaje zwrócone.",
  "Cancel this booking for a full refund of {refund}.":
    "Anuluj tę rezerwację z pełnym zwrotem {refund}.",
  "Cancelling this booking returns {percentage}% of what you paid — {refund}.":
    "Anulowanie tej rezerwacji zwraca {percentage}% zapłaconej kwoty — {refund}.",
  "Cancel this booking?": "Anulować tę rezerwację?",
  "The room will be freed for someone else. This booking is not refundable, so nothing is returned.":
    "Sala zostanie zwolniona dla kogoś innego. Ta rezerwacja nie podlega zwrotowi, więc nic nie zostanie zwrócone.",
  "The room will be freed for someone else and {refund} is refunded to your payment method. Refunds take 5–10 business days to appear.":
    "Sala zostanie zwolniona dla kogoś innego, a {refund} zostanie zwrócone na Twoją metodę płatności. Zwroty pojawiają się w ciągu 5–10 dni roboczych.",
  "The room will be freed for someone else and {refund} — {percentage}% of what you paid — is refunded to your payment method. Refunds take 5–10 business days to appear.":
    "Sala zostanie zwolniona dla kogoś innego, a {refund} — {percentage}% zapłaconej kwoty — zostanie zwrócone na Twoją metodę płatności. Zwroty pojawiają się w ciągu 5–10 dni roboczych.",
  // The change flow — the hero's action and the three steps of its dialog
  "Change booking": "Zmień rezerwację",
  "This booking can no longer be changed. To move it, talk with the space directly.":
    "Tej rezerwacji nie można już zmienić. Aby ją przenieść, skontaktuj się bezpośrednio z przestrzenią.",
  "This booking could be changed until {deadline}. To move it, talk with the space directly.":
    "Tę rezerwację można było zmieniać do {deadline}. Aby ją przenieść, skontaktuj się bezpośrednio z przestrzenią.",
  "Move this booking": "Przenieś tę rezerwację",
  "Pick a new date and time for {room}. Everything else about your booking stays as it is.":
    "Wybierz nową datę i godzinę dla {room}. Wszystko inne w Twojej rezerwacji zostaje bez zmian.",
  "This slot costs {price} for {duration}.":
    "Ten termin kosztuje {price} za {duration}.",
  "This is the slot you already have. Pick a different date or time to move it.":
    "To termin, który już masz. Wybierz inną datę lub godzinę, aby go przenieść.",
  "This slot costs {amount} more, charged when you confirm.":
    "Ten termin kosztuje {amount} więcej — kwota zostanie pobrana przy potwierdzeniu.",
  "This slot costs {amount} more. Your {card} is charged when you confirm.":
    "Ten termin kosztuje {amount} więcej. Twoja {card} zostanie obciążona przy potwierdzeniu.",
  "This slot is cheaper. {amount} is refunded to your payment method.":
    "Ten termin jest tańszy. {amount} zostanie zwrócone na Twoją metodę płatności.",
  "This slot is cheaper. {amount} is refunded to your {card}.":
    "Ten termin jest tańszy. {amount} zostanie zwrócone na Twoją {card}.",
  "This slot is cheaper, but changes are not partially refunded. Your total stays {paid}.":
    "Ten termin jest tańszy, ale zmiany nie podlegają częściowemu zwrotowi. Twoja kwota razem pozostaje {paid}.",
  "Review charge": "Sprawdź opłatę",
  "Review change": "Sprawdź zmianę",
  "Keep current slot": "Zachowaj obecny termin",
  "Move this booking and pay {extra}?":
    "Przenieść tę rezerwację i zapłacić {extra}?",
  "Move this booking?": "Przenieść tę rezerwację?",
  Now: "Teraz",
  "Moving to": "Przenosimy na",
  "Already paid": "Już zapłacono",
  "New slot price": "Cena nowego terminu",
  "To charge now": "Do zapłaty teraz",
  "To refund": "Do zwrotu",
  "Not refunded": "Bez zwrotu",
  "Nothing to pay": "Nic do zapłaty",
  "Your card is charged as soon as you confirm, and the booking moves once the charge goes through.":
    "Twoja karta zostanie obciążona zaraz po potwierdzeniu, a rezerwacja przeniesie się po zaksięgowaniu opłaty.",
  "{amount} is refunded to your payment method. Refunds take 5–10 business days to appear.":
    "{amount} zostanie zwrócone na Twoją metodę płatności. Zwroty pojawiają się w ciągu 5–10 dni roboczych.",
  "{amount} is refunded to your {card}. Refunds take 5–10 business days to appear.":
    "{amount} zostanie zwrócone na Twoją {card}. Zwroty pojawiają się w ciągu 5–10 dni roboczych.",
  "Nothing is charged and nothing is refunded — only the date and time change.":
    "Nic nie zostanie pobrane ani zwrócone — zmieniają się tylko data i godzina.",
  "Nothing is charged. The {amount} difference is not refunded, so your total stays {paid}.":
    "Nic nie zostanie pobrane. Różnica {amount} nie podlega zwrotowi, więc Twoja kwota razem pozostaje {paid}.",
  "Pay {amount} and move": "Zapłać {amount} i przenieś",
  "Move booking": "Przenieś rezerwację",
  "Your booking has moved": "Twoja rezerwacja została przeniesiona",
  "Your new booking": "Twoja nowa rezerwacja",
  "Charged to your {card}": "Obciążono Twoją {card}",
  "Charged to your payment method": "Obciążono Twoją metodę płatności",
  "Refunded to your {card}": "Zwrócono na Twoją {card}",
  "Refunded to your payment method": "Zwrócono na Twoją metodę płatności",
  "Total paid": "Razem zapłacono",
  "A new confirmation is on its way to {email}.":
    "Nowe potwierdzenie jest już w drodze na {email}.",
  "{network} ending {last4}": "{network} kończąca się na {last4}",
  "This slot could not be priced. Try another date or time.":
    "Nie udało się wycenić tego terminu. Wybierz inną datę lub godzinę.",
  "This booking could not be moved. Please try again.":
    "Nie udało się przenieść tej rezerwacji. Spróbuj ponownie.",
  // The recurring quote refusal banner — what the quote refused and the way out
  "This time is sold at a non-refundable rate, which cannot be part of a recurring booking. Try a different day or time, or book this date on its own.":
    "Ten termin jest sprzedawany według stawki bezzwrotnej, która nie może być częścią rezerwacji cyklicznej. Wybierz inny dzień lub godzinę, albo zarezerwuj tę datę osobno.",
  "This promo code makes the booking non-refundable, which cannot be part of a recurring booking. Remove the code, or book this date on its own.":
    "Ten kod promocyjny sprawia, że rezerwacja jest bezzwrotna, więc nie może być częścią rezerwacji cyklicznej. Usuń kod albo zarezerwuj tę datę osobno.",
  "Bookings at this time need the venue's approval, so they cannot repeat yet. Try a different day or time, or book this date on its own.":
    "Rezerwacje o tej godzinie wymagają zgody obiektu, więc nie mogą się jeszcze powtarzać. Wybierz inny dzień lub godzinę, albo zarezerwuj tę datę osobno.",
  "The first date's start time has passed. Update the dates to keep this booking repeating.":
    "Godzina rozpoczęcia pierwszej daty już minęła. Zaktualizuj daty, aby rezerwacja dalej się powtarzała.",
  "The chosen dates no longer fit this room's booking window. Update the dates to keep this booking repeating.":
    "Wybrane daty nie mieszczą się już w oknie rezerwacji tej sali. Zaktualizuj daty, aby rezerwacja dalej się powtarzała.",
  "A recurring booking needs at least 2 dates. Add another date, or book this date on its own.":
    "Rezerwacja cykliczna wymaga co najmniej 2 dat. Dodaj kolejną datę albo zarezerwuj tę datę osobno.",
  "This room no longer offers recurring bookings. You can still book a single date.":
    "Ta sala nie oferuje już rezerwacji cyklicznych. Nadal możesz zarezerwować pojedynczą datę.",
  "We couldn't price this recurring booking. Try different dates, or book a single date instead.":
    "Nie udało się wycenić tej rezerwacji cyklicznej. Wypróbuj inne daty albo zarezerwuj pojedynczą datę.",
  "Update the dates": "Zaktualizuj daty",
  "Book a single date instead": "Zarezerwuj pojedynczą datę",
  "Remove the promo code": "Usuń kod promocyjny",
  Repeat: "Powtarzaj",
  "Ends after": "Kończy się po",
  "Fewer bookings": "Mniej rezerwacji",
  "More bookings": "Więcej rezerwacji",
  "Checking your dates…": "Sprawdzamy Twoje daty…",
  "We couldn't check these dates. Try again.":
    "Nie udało się sprawdzić tych dat. Spróbuj ponownie.",
  "This date isn't available at this time.":
    "Ta data nie jest dostępna o tej godzinie.",
  "This date and time can't repeat inside the booking window.":
    "Ta data i godzina nie mogą się powtarzać w oknie rezerwacji.",
  "Tinted dates are your recurring booking.":
    "Podświetlone daty to Twoja rezerwacja cykliczna.",
  "Review all {count} bookings": "Przejrzyj wszystkie {count} rezerwacji",
  "Review bookings": "Przejrzyj rezerwacje",
  "Dates and repeat": "Daty i powtarzanie",
  "Choose a date": "Wybierz datę",
  "Full-day booking: the daily rate has been applied":
    "Rezerwacja całodniowa: zastosowano stawkę dzienną",
  Table: "Tabela",
  "Ask AI": "Ask AI",
  Beta: "Beta",
  "New chat": "Nowy czat",
  "Ask AI ran into a problem": "W Ask AI wystąpił problem",
  "Reload the page to use Ask AI.": "Odśwież stronę, aby korzystać z Ask AI.",
  "Start a new chat, or reload the page if this keeps happening.":
    "Rozpocznij nowy czat lub odśwież stronę, jeśli problem się powtarza.",
  "We couldn't verify your sign-in. Try again or refresh the page.":
    "Nie udało się potwierdzić Twojego logowania. Spróbuj ponownie lub odśwież stronę.",
  "You don't have access to Ask AI for this account.":
    "Nie masz dostępu do Ask AI na tym koncie.",
  "Ask AI is temporarily unavailable. Try again in a moment.":
    "Usługa Ask AI jest chwilowo niedostępna. Spróbuj ponownie za chwilę.",
  "Something went wrong while getting your answer.":
    "Coś poszło nie tak podczas przygotowywania odpowiedzi.",
  "Couldn't reach Ask AI. Check your connection and try again.":
    "Nie udało się połączyć z Ask AI. Sprawdź połączenie i spróbuj ponownie.",
  "The answer took too long.": "Odpowiedź trwała zbyt długo.",
  "This conversation is too long. Start a new chat.":
    "Ta rozmowa jest za długa. Rozpocznij nowy czat.",
  "What would you like to know?": "Czego chcesz się dowiedzieć?",
  "Ask about your orders, revenue and room usage.":
    "Zapytaj o zamówienia, przychody i wykorzystanie sal.",
  "Suggested questions": "Sugerowane pytania",
  "Suggested follow-up questions": "Sugerowane pytania uzupełniające",
  "How many orders have we had this month?":
    "Ile zamówień mieliśmy w tym miesiącu?",
  "What was our revenue in the last 30 days?":
    "Jaki był nasz przychód w ciągu ostatnich 30 dni?",
  "Which product types are booked the most?":
    "Które typy produktów są najczęściej rezerwowane?",
  "How does this month's revenue compare with last month?":
    "Jak przychód z tego miesiąca wypada w porównaniu z poprzednim miesiącem?",
  "What was meeting-room utilization last month?":
    "Jakie było wykorzystanie sal konferencyjnych w zeszłym miesiącu?",
  "What were last month's unbooked meeting-room hours worth?":
    "Ile były warte niezarezerwowane godziny sal konferencyjnych w zeszłym miesiącu?",
  "How does this month compare with last month?":
    "Jak ten miesiąc wypada w porównaniu z poprzednim?",
  "Ask AI conversation": "Rozmowa z Ask AI",
  "Jump to latest": "Przejdź do najnowszych",
  "Thinking…": "Myślę…",
  "Complex questions can take up to a minute":
    "Złożone pytania mogą zająć do minuty",
  "You stopped this answer": "Zatrzymano tę odpowiedź",
  Failed: "Nie powiodło się",
  Copy: "Kopiuj",
  "Answer copied": "Skopiowano odpowiedź",
  "Good answer": "Dobra odpowiedź",
  "Bad answer": "Zła odpowiedź",
  "What was good about this answer?": "Co było dobrego w tej odpowiedzi?",
  "What went wrong with this answer?": "Co było nie tak z tą odpowiedzią?",
  Accurate: "Trafna",
  Relevant: "Na temat",
  Detailed: "Szczegółowa",
  Other: "Inne",
  Inaccurate: "Nietrafna",
  "Not relevant": "Nie na temat",
  "Too vague": "Zbyt ogólna",
  "Comment (optional)": "Komentarz (opcjonalnie)",
  "Send feedback": "Wyślij opinię",
  "Feedback sent": "Opinia wysłana",
  "Couldn't send your feedback. Try again.":
    "Nie udało się wysłać opinii. Spróbuj ponownie.",
  "Ask a question": "Zadaj pytanie",
  Send: "Wyślij",
  Stop: "Zatrzymaj",
  "Answer ready": "Odpowiedź gotowa",
  "Ask AI from any page": "Ask AI na każdej stronie",
  "Get answers about your orders, revenue and room usage without leaving the page you're on.":
    "Uzyskaj odpowiedzi na temat zamówień, przychodów i wykorzystania sal bez opuszczania bieżącej strony.",
  Shortcut: "Skrót",
  "Got it": "Rozumiem",
  "Get insights on these orders": "Przeanalizuj te zamówienia",
  "Give me insights on these orders.": "Przeanalizuj te zamówienia.",
  "Monthly report": "Raport miesięczny",
  "On the 1st of each month": "1. dnia każdego miesiąca",
  "Last month's revenue, bookings and how full your rooms were, emailed to your team. Choose who gets it, or turn it off.":
    "Przychody, rezerwacje i obłożenie sal z ostatniego miesiąca, wysyłane e-mailem do Twojego zespołu. Wybierz, kto go otrzymuje, lub go wyłącz.",
  "Sent to your admins": "Wysyłane do Twoich administratorów",
  "Monthly report saved.": "Raport miesięczny zapisany.",
  "Flexspace writes and sends this email on the 1st of each month — you choose who gets it.":
    "Flexspace przygotowuje i wysyła ten e-mail 1. dnia każdego miesiąca — Ty wybierasz, kto go otrzymuje.",
  "Who gets it": "Kto go otrzymuje",
  "With no one listed, it goes to your dashboard admins.":
    "Jeśli lista jest pusta, trafia do administratorów Twojego panelu.",
  Search: "Szukaj",
  "Review and sign agreement": "Przejrzyj i podpisz umowę",
  "Page {current} of {total}": "Strona {current} z {total}",
  "Zoom in": "Powiększ",
  "Zoom out": "Pomniejsz",
  "Membership agreement": "Umowa członkowska",
  "Membership agreement (updated)": "Umowa członkowska (zaktualizowana)",
  "Full legal name": "Pełne imię i nazwisko",
  "Type your own full legal name, even if you are signing for a company. This signs the membership agreement.":
    "Wpisz swoje pełne imię i nazwisko, nawet jeśli podpisujesz w imieniu firmy. W ten sposób podpisujesz umowę członkowską.",
  "After you pay, we'll email you the full agreement with your signature.":
    "Po dokonaniu płatności wyślemy Ci e-mailem pełną umowę z Twoim podpisem.",
  "Scroll to the end and type your full legal name to continue.":
    "Przewiń do końca i wpisz swoje pełne imię i nazwisko, aby kontynuować.",
  "This agreement was updated while you were checking out. Please review the latest version and sign again.":
    "Ta umowa została zaktualizowana w trakcie składania zamówienia. Zapoznaj się z najnowszą wersją i podpisz ją ponownie.",
  "Please sign the membership agreement by typing your full legal name.":
    "Podpisz umowę członkowską, wpisując swoje pełne imię i nazwisko.",
  "Please type your full legal name": "Wpisz swoje pełne imię i nazwisko",
  "The agreement could not be displayed here.":
    "Nie udało się tutaj wyświetlić umowy.",
  "Open the agreement": "Otwórz umowę",
  "Higher rate": "Wyższa stawka",
};
